import { apiConfig } from '../config';
import { postFetch } from '../fetch';

export function patchMarkCLessonsAsRead(clessonIds: Array<number>) {
    const { apiPatchMarkCLessonsAsRead } = apiConfig.getStaticUrls();

    return postFetch(apiPatchMarkCLessonsAsRead, {
        clesson_ids: clessonIds.join(','),
    });
}
